/* global wp */
import hubLogo from '../../images/sync/hub.png'
import hubLogo2x from '../../images/sync/hub@2x.png'
import hubTitledLogo from '../../images/sync/hub-tilted.png'
import hubTitledLogo2x from '../../images/sync/hub-tilted@2x.png'

const { __ } = wp.i18n

const HubLogoImage = ({ start }) => {
	return (
		<img
			src={start ? hubLogo : hubTitledLogo}
			srcSet={`${start ? hubLogo : hubTitledLogo} 1x, ${start ? hubLogo2x : hubTitledLogo2x} 2x`}
			className="sui-image"
			alt={__('Connecting...', 'wpmudev')}
		/>
	)
}

export default HubLogoImage
